
import { Component, OnInit, Input, OnChanges, SimpleChanges, NgZone, ViewChild } from '@angular/core';
import { GoogleChartService } from '../services/google-chart.service';
import { Router, ActivatedRoute, RouterEvent, NavigationEnd } from '@angular/router';
import { LoadHist } from '../Models/LoadsData';
import { DatePipe } from '@angular/common';
import { MinMaxDate } from '../Models/MiscModels';
import { MeterService } from '../services/meter.service';
import { SignalrISOdataService } from '../services/signalr-ISOdata.service';
import { MiscService } from '../services/misc.service';
import { NONE_TYPE } from '@angular/compiler/src/output/output_ast';
import { ResizedEvent } from 'angular-resize-event';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-rto-dist',
  templateUrl: './rto-dist.component.html',
  styleUrls: ['./rto-dist.component.css']
})
export class RtoDistComponent implements OnInit, ViewChild {

  public destroyed = new Subject<any>();

  private minMaxDate: MinMaxDate;
  private YearHistTable: any;
  private YearHistDashboard: any;
  private chartTitle: string;

  private YearHistDateSlider: any;
  private width: number;
  private height: number;
  private controlOptions: any;


  constructor(private gChartService: GoogleChartService, private route: ActivatedRoute, private ngZone: NgZone) {

  }
  descendants: boolean;
  first: boolean;
  read: any;
  isViewQuery: boolean;
  selector: any;
  static?: boolean;


  private chartDataYr = new Array<LoadHist>();
  private chartDataSummer = new Array<LoadHist>();
  private chartDataNonSummer = new Array<LoadHist>();

  private options = {
    enableInteractivity: true,

    seriesType: 'scatter',
    series: {
      0: { color: 'grey' },
      1: { color: 'red' },
      2: { color: '#13f9f6' },
    },
    orientation: 'vertical',
    legend: {
      position: 'top', alignment: 'end'
    },

    pointsVisible: true,
    titleTextStyle: {
      color: 'black',    // any HTML string color ('red', '#cc00cc')
      fontName: 'Montesserat', // i.e. 'Times New Roman'
      fontSize: '24', // 12, 18 whatever you want (don't specify px)
      bold: false,    // true or false
      italic: true,   // true of false
    },
    chartArea: { width: '80%', height: '80%' },
    crosshair: { trigger: 'both' },
    curveType: 'function',
    lineWidth: 2,

    //vAxis: { title: 'MW', textStyle: { fontSize: '12' }, format: '#,### MW', textPosition:'out' },
    vAxis: {
      title: 'PJM Load',
      textStyle: {
        color: '#1a237e',
        fontSize: 14,

      },
      format: '#,### MW',
      titleTextStyle: {
        color: '#1a237e',
        fontSize: 18,
        bold: false,
      }
    },

    hAxis: {
      title: 'Percentile',
      textStyle: {
        fontSize: '14'
      },
      format: 'percent',
      gridlines: {
        count: -1,

      },
      minorGridlines: {

      },
      maxValue: 1,
      minValue: 0,
    },

  }
  setFilterOptions() {
    this.controlOptions = {

      'filterColumnIndex': 1,
      ui: {
        'chartOptions': {
          vAxis: { textStyle: { fontSize: '12' }, format: '#,### MW', textPosition: 'out' },
          orientation: 'vertical',
          chartArea: { width: '80%', height: '90%' },
          hAxis: {
            format: 'percent',
            textStyle: {
              fontSize: '12'
            },
            gridlines: {
              count: -1,

            },
            minorGridlines: {

            },


          }
        },
      }

    }
  }

  ngOnInit() {
    var google = this.gChartService.getGoogle();
    google.charts.load('current', { 'packages': ['corechart', 'table', 'controls'] });
    google.charts.setOnLoadCallback(this.drawYearHistChart.bind(this));
    this.route.params.pipe(
      takeUntil(this.destroyed)
    ).subscribe(val => {
      this.chartDataYr = this.route.snapshot.data.rtoYearHistData;
      this.chartDataSummer = this.route.snapshot.data.rtoSummerHistData;
      this.chartDataNonSummer = this.route.snapshot.data.rtoNonsummerHistData;
    });



  }
  formatAxes(YearHistTable) {
    var google = this.gChartService.getGoogle();
    const formatterKW = new google.visualization.NumberFormat({ suffix: ' MW', pattern: '#,###' });
    formatterKW.format(YearHistTable, 0); // Apply formatter to second column

    const formatterPercent = new google.visualization.NumberFormat({ pattern: 'percent' });
    formatterPercent.format(YearHistTable, 1); // Apply formatter to second column
    formatterPercent.format(YearHistTable, 2); // Apply formatter to second column
    formatterPercent.format(YearHistTable, 3); // Apply formatter to second column
  }

  private drawYearHistChart(options) {
    var google = this.gChartService.getGoogle();
    // Create the dataset (DataTable)
    this.YearHistTable = new google.visualization.DataTable();
    this.YearHistTable.addColumn('number', 'MW');
    this.YearHistTable.addColumn('number', 'Complete Year');
    this.YearHistTable.addColumn('number', 'Summer Months(June-Sep)');
    this.YearHistTable.addColumn('number', 'All except Summer Months');

    for (let i = 0; i < this.chartDataYr.length; i++) {
      let chartRow = new Array<number>();

      if (this.chartDataYr[i].mW == 0)
        this.chartDataYr[i].mW = null;
        
      chartRow.push(this.chartDataYr[i].mW);

      chartRow.push(this.chartDataYr[i].percentile);

      chartRow.push(this.chartDataSummer[i].percentile);
      chartRow.push(this.chartDataNonSummer[i].percentile);

      this.YearHistTable.addRow(chartRow);
    }
    this.chartTitle = 'Load Curve: PJM RTO Load (MW) versus Cumulative Percentile';


    // Create a dashboard.
    const dash_container = document.getElementById('YearHistdashboard_div');

    this.YearHistDashboard = new google.visualization.Dashboard(dash_container);

    // Create a date range slider
    this.YearHistDateSlider = new google.visualization.ControlWrapper({
      'controlType': 'ChartRangeFilter',
      'containerId': 'YearHistcontrol_div',
      'state': { 'range': { 'start': 0, 'end': 38 } }
    });
    this.setFilterOptions();
    this.YearHistDateSlider.setOptions(this.controlOptions);

    this.formatAxes(this.YearHistTable);

    // Line chart visualization
    var YearHistLine = new google.visualization.ChartWrapper({
      'chartType': 'ComboChart',
      'containerId': 'YearHistline_div',

      'options': this.options,
    });

    YearHistLine.setOption('title', this.chartTitle);
    // Bind YearHistLine to the dashboard, and to the controls
    // this will make sure our line chart is updated when our date changes
    this.YearHistDashboard.bind(this.YearHistDateSlider, YearHistLine);

    this.YearHistDashboard.draw(this.YearHistTable);
    var columns = [];
    var series = {};
    for (var i = 0; i < this.YearHistTable.getNumberOfColumns(); i++) {
      columns.push(i);
      if (i > 0) {
        series[i - 1] = {};
      }
    }
  }

  onResized(event: ResizedEvent) {
    this.width = event.newWidth;
    this.height = event.newHeight;


    console.log('width', this.width);
    console.log('height', this.height);

    if (this.YearHistDashboard != undefined) {
      this.YearHistDashboard.draw();
      this.YearHistDateSlider.draw();
    }
  }
  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}

